export default __webpack_public_path__ + "static/media/green1-small.7aa009c9.png";